import { CheckIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { Separator } from "@/core/components/ui/separator";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

interface OnboardingActionButtonProps {
  text: string;
  isCompleted: boolean | undefined;
  onClick: () => void;
  checkIconColor?: string;
}

export const OnboardingActionButton = ({
  text,
  isCompleted,
  onClick,
  checkIconColor = "text-green-600",
}: OnboardingActionButtonProps) => {
  const completed = Boolean(isCompleted);

  return (
    <>
      <Stack className="relative" fullWidth>
        <button
          onClick={onClick}
          disabled={completed}
          className={`flex w-full items-center justify-between p-3 text-left transition-colors ${
            completed
              ? "cursor-default opacity-50"
              : "cursor-pointer hover:bg-gray-50"
          }`}
        >
          <Typography
            variant="bodyW1"
            className={completed ? "line-through" : ""}
          >
            {text}
          </Typography>
          {!completed && (
            <ChevronRightIcon className="h-4 w-4 text-secondary-text" />
          )}
        </button>
        {completed && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            <CheckIcon className={`h-4 w-4 ${checkIconColor}`} />
          </div>
        )}
      </Stack>
      <Separator />
    </>
  );
};
